var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamcorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M525.625 165.75L416 241.25V398.75L525.625 474.25C546.75 488.75 576 473.875 576 448.375V191.5C576 166.125 546.875 151.125 525.625 165.75ZM320 160H96V128C96 110.4 110.4 96 128 96H288C305.673 96 320 81.673 320 64V64C320 46.327 305.673 32 288 32H128C74.981 32 32 74.981 32 128V162.875C12.875 169.5 0 187.5 0 207.75V416C0 451.346 28.654 480 64 480H320C355.346 480 384 451.346 384 416V224C384 188.654 355.346 160 320 160ZM304 256H80C71.164 256 64 248.836 64 240C64 231.162 71.164 224 80 224H304C312.838 224 320 231.162 320 240C320 248.836 312.838 256 304 256Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamcorder);
export default __webpack_public_path__ + "static/media/camcorder.c63f9a6a5a7fa59b3958cfb2a8bda9d0.svg";
export { ForwardRef as ReactComponent };